import { html, render } from 'lit-html'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'
import { contextualize, cutlassEvent } from '@polleverywhere/cutlass'
import Join from './join'
import Recent from './recent'
import { pollevBanner } from './banner'
import LogoTpl from '@polleverywhere/toolkit/lib/templates/logo.hamlc'

import '../../components/layout_tab_bar'

import './style.scss'

export default class Home extends Backbone.View {
  get className () { return 'pollev-home' }

  get events () {
    return {
      'change:active layout-tab-bar' (e) {
        this.trigger('navigate', e.detail.route)
      },

      'click:logout section-header': () => {
        this.trigger('navigate', 'logout')
      }
    }
  }

  initialize (options) {
    this.state = options.state
    this.join = new Join()
    this.recent = new Recent()

    this.listenTo(this.join, 'join', this.handleJoin)
    this.listenTo(this.recent, 'join', this.handleJoin)

    contextualize(this.el, 'home')
  }

  handleJoin (username, exists) {
    if (exists) {
      this.state.joinPresenterSession(username)
    }
    cutlassEvent(this.el, 'find_presenter', { successful: exists })
  }

  render () {
    render(html`<layout-tab-bar
    active='home' profile='participant'>
      <main slot='content'>
        ${unsafeSVG(LogoTpl())}
        ${this.join.render().el}
        <div class=pollev-home__wrapper>${pollevBanner(this.el, this.state)}</div>
        ${this.recent.render().el}
      </main>
    </layout-tab-bar>`, this.el)

    return this
  }

  remove () {
    this.join.remove()
    this.recent.remove()

    super.remove()
  }
}
